import { render, staticRenderFns } from "./AccountsDataTable.vue?vue&type=template&id=29ec7c80"
import script from "./AccountsDataTable.vue?vue&type=script&lang=js"
export * from "./AccountsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports